<style lang="stylus">
    .focus-expand-container
        position fixed
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 3
        pointer-events none
        .focus-block
            display flex
            justify-content center
            align-items center
            background var(--bg-color-focus-page-arrow)
            border-radius 5px
            cursor pointer
            user-select none
            opacity var(--opacity-focus-page-arrow)
            pointer-events auto
            &:hover
                background var(--bg-color-focus-page-arrow-hover)
            svg
                width 20px
                height 20px
        .focus-expand-line
            position absolute
            display flex
            justify-content center
            align-items center
            &:hover
                .focus-block
                    opacity 1
        .focus-expand-top
            left 0
            right 0
            top 0
            height 80px
            .focus-block
                width 64px
                height 32px
                &.active
                    svg
                        transform rotate(180deg)
        .focus-expand-right
            right 0
            top 0
            bottom 0
            width 80px
            .focus-block
                width 32px
                height 64px
                svg
                    transform rotate(90deg)
                &.active
                    svg
                        transform rotate(270deg)
        .focus-expand-bottom
            left 0
            right 0
            bottom 0
            height 80px
            .focus-block
                width 64px
                height 32px
                svg
                    transform rotate(180deg)
                &.active
                    svg
                        transform rotate(0deg)
        .focus-expand-left
            left 0
            top 0
            bottom 0
            width 80px
            .focus-block
                width 32px
                height 64px
                svg
                    transform rotate(-90deg)
                &.active
                    svg
                        transform rotate(90deg)
    .hidden-expand
        .focus-block
            display none
</style>

<template>
    <div class="focus-expand-container" :class="{ 'hidden-expand': hideFocusArrow }">
        <div class="focus-expand-top focus-expand-line" :style="getOffsetStyle(0)">
            <div class="focus-block" :class="{ active: focusModeExpandTop }" @click="togglePanel(0)">
                <iconSymbol name="focus-arrow" />
            </div>
        </div>
        <div class="focus-expand-right focus-expand-line" :style="getOffsetStyle(1)">
            <div class="focus-block" :class="{ active: focusModeExpandRight }" @click="togglePanel(1)">
                <iconSymbol name="focus-arrow" />
            </div>
        </div>
        <div class="focus-expand-bottom focus-expand-line" :style="getOffsetStyle(2)">
            <div class="focus-block" :class="{ active: focusModeExpandBottom }" @click="togglePanel(2)">
                <iconSymbol name="focus-arrow" />
            </div>
        </div>
        <div class="focus-expand-left focus-expand-line" :style="getOffsetStyle(3)">
            <div class="focus-block" :class="{ active: focusModeExpandLeft }" @click="togglePanel(3)">
                <iconSymbol name="focus-arrow" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({})
    export default class FocusExpand extends Vue {
        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }
        get focusExpand() {
            return this.$store.state.ui.focusExpand;
        }
        set focusExpand(v) {
            this.$store.commit("setStatus", {
                type: "focusExpand",
                data: v,
            });
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        get focusModeExpandBottom() {
            return this.$store.getters.expandBottom;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }

        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop + "px";
        }
        get sceneRight() {
            if (!this.focusModeExpandRight) return 0;
            if (this.$store.state.ui.showRightPanel) return this.$store.state.ui.sceneRight + "px";
            else return "50px";
        }
        get sceneBottom() {
            if (!this.focusModeExpandBottom) return 0;
            return 35 + "px";
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft + "px";
        }
        get hideFocusArrow() {
            return window["EDCONFIG"].IS_SDK;
        }

        expandLib() {
            this.$store.commit("setStatus", {
                type: "showLibrary",
                data: true,
            });
            this.$bus.$emit("toggleLibrary");
        }
        togglePanel(type) {
            let index = this.focusExpand.indexOf(type);
            (index == -1 && this.focusExpand.push(type)) || this.focusExpand.splice(index, 1);
            // this.focusExpand.length == 4 && this.$bus.$emit('exitFocus');
            type == 3 && this.expandLib();
            localStorage.setItem("focusExpand", JSON.stringify(this.focusExpand));
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }

        getOffsetStyle(type) {
            let style = "";
            switch (type) {
                case 0:
                    style = `top: ${this.sceneTop}`;
                    break;
                case 1:
                    style = `right: ${this.sceneRight}`;
                    break;
                case 2:
                    style = `bottom: ${this.sceneBottom}`;
                    break;
                case 3:
                    style = `left: ${this.sceneLeft}`;
                    break;
            }
            return style;
        }

        mounted() {
            let focusExpand = localStorage.getItem("focusExpand");
            if (focusExpand) {
                this.focusExpand = JSON.parse(focusExpand);
            }
        }

        created() {
            this.$bus.$on("focusExpandPanel", this.togglePanel);
        }
        beforeDestroy() {
            this.$bus.$off("focusExpandPanel", this.togglePanel);
        }
    }
</script>
